import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';
import { TextInput, LabelGroup, Text, Flex } from '~/views';

import style from './style.css'

export default class ScriptInfoEditor extends React.Component {

  static propTypes = {
    template : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false }
  }

  changePath( path, value, err ) {
    if ( err ) {
      console.log( `error setting ${key} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.template, path, value } );
    this.forceUpdate() // hacky  
  }

  render() {
    console.log( 'props', this.props )
    const { template } = this.props
    
    if ( template == null ) {
      return <div />
    }

    return (
      <Flex variant="vSpace" direction="column" align="stretch" className={style.pad}>
        <LabelGroup>
          <label>ID</label>
          <Text type="dim" text={template.id} />
        </LabelGroup>
        <LabelGroup>
          <label>Name</label>
          <TextInput
            hint="Name..."
            value={template.name}
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
        </LabelGroup>
        <LabelGroup>
          <label>Alias</label>
          <TextInput
            hint="Alias..."
            value={template.alias}
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'alias', v, err ) }} />
        </LabelGroup>
        <LabelGroup>
          <label>Description</label>
          <TextInput
            hint="Description..."
            value={template.description}
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'description', v, err ) }} />
        </LabelGroup>
        <LabelGroup>
          <label>Status</label>
          <Text type="dim" className={style.identifier}>
            {template.status}
          </Text>
        </LabelGroup>
        <LabelGroup>
          <label />
          <Text type="dim" className={style.identifier}>
            {`created ${moment( template.created ).format( 'lll' )}` }
          </Text>
        </LabelGroup>
          
      </Flex>
    ) 
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-:]/.test( inp ) ) {
    return true;
  }
  return false;
}
